import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { hasAnyJwtAuthority } from '../../utils/tokenUtils';
import {
    GLOBAL_ADMIN_AUTHORITIES,
    TENANT_DASHBOARD_AUTHORITIES,
} from '../../constants';

const menuLinks = [
    {
        label: 'Global Administration',
        to: '/admin/global',
        requiredAuthorities: GLOBAL_ADMIN_AUTHORITIES,
    },
    {
        label: 'Tenant Administration',
        to: '/admin/tenant',
        requiredAuthorities: TENANT_DASHBOARD_AUTHORITIES,
    },
];

const UserMenuLinks = () => {
    const visibleLinks = menuLinks.filter(({ requiredAuthorities }) => {
        if (requiredAuthorities && requiredAuthorities.length > 0) {
            return hasAnyJwtAuthority(requiredAuthorities);
        }
        return true;
    });

    if (visibleLinks.length === 0) return null;

    return (
        <>
            <Dropdown.Divider as="div" />
            {visibleLinks.map(({ label, to }) => (
                <Dropdown.Item key={to} as={Link} to={to}>
                    {label}
                </Dropdown.Item>
            ))}
        </>
    );
};

export default UserMenuLinks;
